import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { FilterDto } from '@maporium-workspace/shared';

@Injectable({ providedIn: 'root' })
export class FilterResource {
  private readonly baseUrl = environment.apiUrl + '/filters';

  constructor(private http: HttpClient) {}

  getOne(id: string) {
    return this.http.get<FilterDto>(this.baseUrl + '/' + id);
  }

  getAll(mapId: string) {
    return this.http.get<FilterDto[]>(this.baseUrl + '/map/' + mapId);
  }

  getAllGlobal() {
    return this.http.get<FilterDto[]>(this.baseUrl + '/global');
  }

  create(filter: Partial<FilterDto>) {
    return this.http.post<FilterDto>(this.baseUrl, filter);
  }

  update(id: string, filter: Partial<FilterDto>) {
    return this.http.patch<FilterDto>(this.baseUrl + '/' + id, filter);
  }

  delete(filterId: string) {
    return this.http.delete<void>(this.baseUrl + '/' + filterId);
  }
}